import React, { useEffect, useRef, useState, useMemo, memo } from "react";
import { useSelector } from "react-redux";
import "react-image-lightbox/style.css";

import { selectProductDetails } from "../selectors";

import View from "../../../components/common/view";
import { DiscountLabel } from "../../../components/price/priceSlab";
import ProductOverlayTag from "../../../components/product/productOverlayTag";
import { SyteSearchSimilarItemsButton } from "../../../components/syte/syteSearchSimilarItemsButton";

import ShareInfo from "./shareInfo";
import MainImage from "./mainImage";
import MobileImage from "./mobileImage";
import SideImages from "./sideImages";

import "./style.scss";
import PdpAnalyticsEvent from "../../../services/analytics/main/pdp";

const ProductDetailImage = ({ thumbLength, shareButton }) => {
  const product = useSelector(selectProductDetails);

  const imageList = useMemo(
    () => [
      product.captionImageURL,
      ...(Array.isArray(product.images) ? product.images : [])
    ],
    [product]
  );

  const [activeImageIndex, setActiveImageIndex] = useState(0);

  const slider1Ref = useRef(null);
  const slider2Ref = useRef(null);
  const sliderContainerRef = useRef(null);
  const zoomedBlockRef = useRef(null);

  const [isHover, setIsHover] = useState(false);
  const [backgroundPosition, setBackgroundPosition] = useState("");
  const [backgroundImage, setBackgroundImage] = useState("");

  const handleImageMouseMove = ({
    isHover,
    backgroundPosition,
    backgroundImage
  }) => {
    setIsHover(isHover);
    setBackgroundPosition(backgroundPosition);
    setBackgroundImage(backgroundImage);
  };

  const handleImageMouseOut = () => {
    setBackgroundImage("");
    setIsHover(false);
  };

  const handleShareBtnClick = evt => {
    let element = evt.target;
    while (element) {
      if (element.hasAttribute("data-share")) {
        const shareBy = element.getAttribute("data-share");
        PdpAnalyticsEvent.share({
          shareBy,
          productSKU: product.id
        });
        break;
      }
      element = element.parentElement;
    }
  };

  return (
    <div className="item_detail_preview" id="item-preview">
      <View.desktop className="item_preview_web" key={product.id}>
        <SideImages
          sliderRef={slider2Ref}
          imageList={imageList}
          thumbLength={thumbLength}
          activeImageIndex={activeImageIndex}
          setActiveImageIndex={setActiveImageIndex}
        />

        <span ref={sliderContainerRef}>
          <MainImage
            imageList={imageList}
            sliderRef={slider1Ref}
            sliderContainerRef={sliderContainerRef}
            handleImageMouseMove={handleImageMouseMove}
            handleImageMouseOut={handleImageMouseOut}
            zoomedBlockRef={zoomedBlockRef}
            activeImageIndex={activeImageIndex}
            setActiveImageIndex={setActiveImageIndex}
          />
        </span>
      </View.desktop>

      <View.mobile key={product.id}>
        <MobileImage imageList={imageList} />
      </View.mobile>

      <View.desktop className="image_discount_block">
        <DiscountLabel product={product} showOffText />
      </View.desktop>
      <View.mobile className="image_discount_block">
        <DiscountLabel
          product={product}
          showOffText={false}
          showDiscountPrefix
        />
      </View.mobile>

      <ProductOverlayTag
        overlayLabel={product.overlayTagLabel?.label}
        overlayTagBgColor={product.overlayTagLabel?.style?.backgroundColor}
        overlayTagLabelColor={product.overlayTagLabel?.style?.textColor}
      />

      {shareButton && (
        <ShareInfo
          pinterestImage={product.captionImageURL}
          onMethodClick={handleShareBtnClick}
        />
      )}
      {isHover && (
        <div
          ref={zoomedBlockRef}
          className="zoom-container"
          style={{
            backgroundPosition: backgroundPosition,
            backgroundImage: `url(${backgroundImage})`
          }}
        />
      )}
      <SyteSearchSimilarItemsButton />
    </div>
  );
};

export default memo(ProductDetailImage);
